"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var message_receiver_control_registration_params_serialiser_1 = require("./message-receiver-control-registration-params-serialiser");
/**
 * Serialiser for {@link MessageReceiverControlRegistrationRequest}
 */
var MessageReceiverControlRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MessageReceiverControlRegistrationRequestSerialiserClass, _super);
    function MessageReceiverControlRegistrationRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link MessageReceiverControlRegistrationRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MessageReceiverControlRegistrationRequest} to be written
     */
    MessageReceiverControlRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
        message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser.write(bos, value.params);
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
    };
    return MessageReceiverControlRegistrationRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessageReceiverControlRegistrationRequestSerialiserClass = MessageReceiverControlRegistrationRequestSerialiserClass;
/**
 * The {@link MessageReceiverControlRegistrationRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessageReceiverControlRegistrationRequestSerialiser = new MessageReceiverControlRegistrationRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/message-receiver-control-registration-request-serialiser.js
// module id = 1215
// module chunks = 1